export const signUpContainerSx = (theme: { palette: { mode: string } }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor: theme.palette.mode === 'light' ? '#FFFFFF' : '#ffffff1a',
  width: '438px',
  minHeight: '438px',
  boxShadow: '0 8px 40px #0003',
  borderRadius: '8px',
  padding: '32px 32px 20px',
});
